module.exports = __webpack_public_path__ + "img/HeaderLogo2024.0227760f.png";